<template>
    <footer class="footer spad">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="footer__about">
            <div class="footer__about__logo">
              <a href="#" class="logo">Ecom Vue</a>
            </div>
            <ul>
              <li>Address: 4, Mohakhali, Dhaka-1214</li>
              <li>Phone: 111-222-333</li>
              <li>Email: test@test.com</li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-1">
          <div class="footer__widget">
            <h6>Useful Links</h6>
            <ul>
              <li><router-link to="about-us">About Us</router-link></li>
              <li><router-link to="/shop">Our Shop</router-link></li>
              <li><a href="#">Secure Shopping</a></li>
              <li><a href="#">Delivery Infomation</a></li>
              <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
              <li><a href="#">Tracking Your Products</a></li>
            </ul>
            <ul>
              <li><a href="#">Our Services</a></li>
              <li><a href="#">Who We Are</a></li>
              <li><a href="#">Our Projects</a></li>
              <li><router-link to="/contact-us">Contact</router-link></li>
              <li><a href="#">Testimonials</a></li>
              <li><a href="#">Our Clients</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="footer__widget">
            <h6>Join Our Newsletter Now</h6>
            <p>Get E-mail updates about our latest shop and special offers.</p>
            <form action="#">
              <input type="text" placeholder="Enter your mail" />
              <button type="submit" class="site-btn">Subscribe</button>
            </form>
            <div class="footer__widget__social">
              <a href="#"><i class="fa fa-facebook"></i></a>
              <a href="#"><i class="fa fa-instagram"></i></a>
              <a href="#"><i class="fa fa-twitter"></i></a>
              <a href="#"><i class="fa fa-pinterest"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="footer__copyright">
            <div class="footer__copyright__text">
              <p>
                Copyright &copy;2021 All rights reserved | This Vue Application
                is made with <i class="fa fa-heart" aria-hidden="true"></i> by
                <a href="https://mdmostafa.com" target="_blank">Mostafa</a>
              </p>
            </div>
            <div class="footer__copyright__payment">
              <img src="assets/img/payment-item.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>